import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

/**
 * Disclaimer banner shown above non-FR versions of legal pages
 * (CGU, Mentions Légales / RGPD, Refund Policy, etc.).
 *
 * In French law, the FR version of a commercial site's legal pages is
 * authoritative; translations into other languages are "traduction de
 * courtoisie" (informational courtesy translations). This banner makes
 * that explicit and offers a one-click switch back to the FR version.
 *
 * Renders nothing when current language is FR.
 */
const LegalDraftBanner = () => {
  const { t, i18n } = useTranslation();

  if (i18n.language === 'fr') {
    return null;
  }

  const switchToFR = () => {
    i18n.changeLanguage('fr');
  };

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/30">
      <div className="max-w-[900px] mx-auto px-6 md:px-12 py-4">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-amber-100 text-sm leading-relaxed">
              {t('legalPages.draftBanner')}
            </p>
            <button
              onClick={switchToFR}
              className="text-amber-300 hover:text-amber-200 text-sm font-medium underline mt-1"
            >
              {t('legalPages.draftBannerLink')} →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalDraftBanner;
